import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"

type OrganizationConfig = {
  appName: string
}

const retrieveMerchantGroupOrganizationConfig =
  async () => {
    const { body } = await api.get<OrganizationConfig>(
      "/merchant-group/get-organization-config/",
      {
        isMerchantGroup: true,
      }
    )
    return body
  }

export const useMerchantGroupOrganizationConfig = () => {
  const { data } = useQuery({
    queryKey: [
      BASE_MERCHANT_GROUP_CURRENT_ORGANIZATION_CONFIG_QUERY_KEY,
    ],
    queryFn: retrieveMerchantGroupOrganizationConfig,
  })

  return { organizationConfig: data }
}
